import { MtProject } from "server/models"
import { OrderType } from "client/utils"
import { ProjectSettings } from "client/store"

export interface ProjectProps {
    projectId: number
}

export type ProjectActiveModules = { [key: string]: boolean }
export type ProjectValidation = { [key in keyof MtProject]?: string}

export interface ProjectList { [projectId: number]: MtProject }
export interface ProjectFilters {
    owner?: number
    search?: string
}

export interface ProjectState {
    projectList: ProjectList
    projectIds: readonly number[]
    projectView: MtProject
    projectEdit: MtProject

    projectSettings: ProjectSettings

    sortColumn: keyof MtProject
    sortOrder: OrderType
    filters: ProjectFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const PROJECT_LIST = "PROJECT_LIST"
export const PROJECT_IDS = "PROJECT_IDS"
export const PROJECT_VIEW = "PROJECT_VIEW"
export const PROJECT_EDIT = "PROJECT_EDIT"

export const PROJECT_PROJECT_SETTINGS = "PROJECT_PROJECT_SETTINGS"

export const PROJECT_SORT = "PROJECT_SORT"
export const PROJECT_FILTERS = "PROJECT_FILTERS"

export const PROJECT_RELOAD_LIST = "PROJECT_RELOAD_LIST"
export const PROJECT_RELOAD_VIEW = "PROJECT_RELOAD_VIEW"
export const PROJECT_RELOAD_EDIT = "PROJECT_RELOAD_EDIT"
